import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomePlayButtonComponent } from './home-play-button.component';

@NgModule({
  imports: [CommonModule, HomePlayButtonComponent],
  exports: [HomePlayButtonComponent],
})
export class HomePlayButtonModule {}
